export enum ZpusobProvedeniAkce {
	MANUALNE = 'MANUALNE',
	AUTOMATICKY = 'AUTOMATICKY'
}
